import React, { useEffect, useState } from "react";
import { SubOptionType } from "../../../services/helpers/types";
import {
  closestCenter,
  DndContext,
  KeyboardSensor,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  restrictToVerticalAxis,
  restrictToParentElement,
} from "@dnd-kit/modifiers";
import {
  sortableKeyboardCoordinates,
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";
import DraggableSelectSubOptionsItem from "../DraggableSelectSubOptionsItem/DraggableSelectSubOptionsItem";

interface DraggableSelectSubOptionsListProps {
  options: SubOptionType[];
  onOptionChange: (option: SubOptionType) => void;
  onDeleteItem: (itemID: number) => void;
  onChangePosition: (newItemsPositions: number[]) => void;
}

const DraggableSelectSubOptionsList = (
  props: DraggableSelectSubOptionsListProps
) => {
  const { options, onDeleteItem, onOptionChange, onChangePosition } = props;
  const [items, setItems] = useState<number[]>([]);

  useEffect(() => {
    const optionPositions = options.map((option) => option.position);
    setItems(optionPositions);
  }, [options]);

  const updatedItems = (items: number[], active: any, over: any) => {
    const oldIndex = items.indexOf(active.id);
    const newIndex = items.indexOf(over.id);

    return arrayMove(items, oldIndex, newIndex);
  };
  const handleDragEnd = (event: any) => {
    const { active, over } = event;

    if (active && over && active.id !== over.id) {
      const newItems = updatedItems(items, active, over);

      setItems(newItems);
      onChangePosition(newItems);
    }
  };

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
    useSensor(TouchSensor)
  );

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
      modifiers={[restrictToVerticalAxis, restrictToParentElement]}
    >
      <SortableContext items={items} strategy={verticalListSortingStrategy}>
        {items.map((position) => (
          <DraggableSelectSubOptionsItem
            key={position}
            id={position}
            option={options.find((item) => item.position === position)}
            subOptions={options}
            onDelete={onDeleteItem}
            onOptionChange={onOptionChange}
          />
        ))}
      </SortableContext>
    </DndContext>
  );
};

export default DraggableSelectSubOptionsList;
